import React, { Component } from 'react';
import { Dialog, DialogTitle, DialogContent, TextField, InputAdornment, DialogActions, Button, CircularProgress } from '@material-ui/core';
import { connect } from 'react-redux'

import questionsService from '../../api/questionsService';
import { cleanSelectedQuestion } from '../../redux/actions/questionsActions';
import { showSuccess } from '../../redux/actions/snackbarActions'
import { bindActionCreators } from 'redux';


class QuestionForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: '',
            ordenation: '',
            question: '',
            isSaving: false
        };

        this._setQuestion = this._setQuestion.bind(this);
        this._saveQuestion = this._saveQuestion.bind(this);
        this._setQuestionDetails = this._setQuestionDetails.bind(this);
    }

    _setQuestion = ({ target }) => {
        this.setState({
            question: target.value
        });
    }

    _saveQuestion = () => {
        const { id, question } = this.state;
        const { subcategory, hideModal } = this.props;
        this.setState({
            isSaving: true
        });

        if (Boolean(id)) {
            questionsService.changeQuestion(id, question)
                .then(() => {
                    this.setState({
                        isSaving: false
                    });

                    this.props.showSuccess('Question updated successfully.');
                    this.props.cleanSelectedQuestion();
                    hideModal();
                });
        } else {
            questionsService.createQuestion(question, subcategory)
                .then(() => {
                    this.setState({
                        isSaving: false
                    });

                    this.props.showSuccess('Question created successfully.');
                    hideModal();
                });
        }
    }

    _setQuestionDetails = () => {
        if (Boolean(this.props.selectedQuestion)) {
            const { id, query, ordenation } = this.props.selectedQuestion;
            this.setState({
                id,
                question: query,
                ordenation
            });
        } else {
            this.setState({
                id: '',
                question: '',
                ordenation: ''
            });
        }
    }

    render() {
        const { showModal, hideModal, categories, category, subcategory } = this.props;
        let categoryName;
        if (Boolean(category) && Boolean(subcategory)) {
            categoryName = categories.filter((cat) => cat.id === category)[0]
                .subcategories.filter((subcat) => subcat.id === subcategory)[0].name;
        }
        const isEditing = Boolean(this.state.id);
        return (
            <Dialog onRendered={() => {
                this._setQuestionDetails();
            }} open={showModal} onClose={() => {
                this.props.cleanSelectedQuestion();
                hideModal();
            }} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{isEditing ? "Editing" : "Creating"} a question for {categoryName}</DialogTitle>
                <DialogContent>
                    <TextField
                        variant="outlined"
                        margin="normal"
                        id="question"
                        label="Write a question"
                        type="text"
                        onChange={this._setQuestion}
                        value={this.state.question}
                        fullWidth
                    />
                </DialogContent>
                <DialogActions>
                    <Button color="primary" onClick={hideModal}>Back</Button>
                    <Button color="primary" onClick={this._saveQuestion} disabled={this.state.isSaving}>{isEditing ? "Save" : "Add"}</Button>
                    {this.state.isSaving && <CircularProgress size={24} />}
                </DialogActions>
            </Dialog>
        )
    }
}

const mapStateToProps = ({ categoryState, questionState }) => ({
    categories: categoryState.categories,
    selectedQuestion: questionState.selectedQuestion
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ showSuccess, cleanSelectedQuestion }, dispatch)
);


export default connect(mapStateToProps, mapDispatchToProps)(QuestionForm);